import { render } from "./GestionePreventiviPratiche.vue?vue&type=template&id=93c81d66"
import script from "./GestionePreventiviPratiche.vue?vue&type=script&lang=js"
export * from "./GestionePreventiviPratiche.vue?vue&type=script&lang=js"

import "./GestionePreventiviPratiche.vue?vue&type=style&index=0&id=93c81d66&lang=css"

import exportComponent from "/Users/gigi/Library/ask_admin-deps/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__